import FloatingTooltip from "@components/common/FloatingTooltip";
import { useTranslation } from "react-i18next";
import { Card, Passenger } from "@gen/travel/v1/common_pb";
import i18n from "@libs/i18n";

type PaxDetailsProps = {
  pax: Passenger;
};

export default function PaxDetails({ pax }: PaxDetailsProps) {
  const { t } = useTranslation();

  function formatBirthDate(date: string) {
    return Intl.DateTimeFormat(i18n.language, {
      day: "numeric",
      month: "numeric",
      year: "numeric",
    }).format(new Date(date));
  }

  return (
    <FloatingTooltip
      content={
        <div className="flex flex-col">
          <span className="text-white text-xs flex">
            {t("search.passenger.name")} : {pax.firstName} {pax.lastName}
          </span>
          {pax.birthDate && (
            <span className="text-white text-xs flex">
              {t("search.passenger.birthdate")} :{" "}
              {formatBirthDate(pax.birthDate)}
            </span>
          )}
          <span className="text-white text-xs flex">
            {t("search.passenger.phone")} : {pax.phoneNumber}
          </span>
          {pax.cards && (
            <div className="mt-1">
              {pax.cards.map((card: Card, index: number) => (
                <span key={index} className="text-white text-xs flex">
                  {card.type}
                </span>
              ))}
            </div>
          )}
        </div>
      }
    >
      <span className="text-base text-text-strong font-normal">
        {pax.firstName} {pax.lastName}
      </span>
    </FloatingTooltip>
  );
}
